import { render, staticRenderFns } from "./lostAndFound.vue?vue&type=template&id=2c62771c"
import script from "./lostAndFound.vue?vue&type=script&lang=js"
export * from "./lostAndFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports